import * as React from "react";
import { MoreVertical } from "lucide-react";
import { Button } from "../../components/ui/button";
import { DropdownMenu, DropdownMenuContent, DropdownMenuTrigger, } from "../../components/ui/dropdown-menu";
export const MoreMenu = ({ className, children, modal = false, }) => (React.createElement(DropdownMenu, { modal: modal },
    React.createElement(DropdownMenuTrigger, { asChild: true },
        React.createElement(Button, { variant: "ghost", size: "icon", className: className },
            React.createElement("span", { className: "sr-only" }, "Men\u00FC \u00F6ffnen"),
            React.createElement(MoreVertical, { className: "h-4 w-4" }))),
    React.createElement(DropdownMenuContent, { align: "end" }, children)));
//# sourceMappingURL=MoreMenu.js.map